<div class="basicrow m-top">
    <div class="autowcont m-bott">
        <div class="basicrow msidespad">
            <div class="b-title">
                <div class="autocont f-black roboto-m f-bmed pull-left vcenter">
                    <div class="tabcell">
                        Crear Nuevo Usuario
                    </div>
                </div>
            </div>
        </div>
        <div class="basicrow m-top-u msidespad">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <div class="basicrow m-bott">
                        <label class="label-f">&#42; N&uacute;mero de cuenta</label>
                        <div class="basicrow rel">
                            <select class="sel-f" (change)="changeAccount($event)" [(ngModel)]="this.account"
                                style="background-image:url(/assets/images/selectabarrw.png)">
                                <option disabled value="">Seleccionar la cuenta</option>
                                <option *ngFor="let list of this.banList; let i = index" [ngValue]="list.account">
                                    {{list.account}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="basicrow m-bott">
                        <label class="label-f">&#42; N&uacute;mero de tel&eacute;fono</label>
                        <div class="basicrow rel">
                            <select class="sel-f" [(ngModel)]="this.phoneNumber"
                                style="background-image:url(/assets/images/selectabarrw.png)">
                                <option disabled value="">Seleccionar el número teléfonico</option>
                                <ng-container *ngFor="let list of this.subscribersList; let i = index">
                                    <option *ngIf="list.subscriber!=this.defaultSubscriber" [ngValue]="list.subscriber">
                                        {{list.subscriber}}
                                    </option>
                                </ng-container>
                            </select>
                        </div>
                    </div>
                    <div class="basicrow m-bott">
                        <label class="label-f">&#42; Nombre</label>
                        <div class="basicrow rel">
                            <input class="inp-f qt" [(ngModel)]="this.name">
                        </div>
                    </div>
                    <div class="basicrow m-bott">
                        <label class="label-f">&#42; Apellido</label>
                        <div class="basicrow rel">
                            <input class="inp-f qt" [(ngModel)]="this.lastName">
                        </div>
                    </div>
                    <div class="basicrow m-bott">
                        <label class="label-f">&#42; Correo electrónico</label>
                        <div class="basicrow rel">
                            <input class="inp-f qt" [(ngModel)]="this.email">
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <div *ngFor="let role of this.rolesList; let i = index">
                        <div class="optchoice on roboto-r text-left" [ngClass]="{'on': this.statusOn[i] == true}"
                            (click)="this.changeType(i,role.id_role,role.name);">
                            <div class="checkdef">
                                <input type="radio" name="radioG1" id="radioG1" class="css-radio"
                                    [checked]="this.statusRadio[i] == true" /><label for="radioG1"
                                    class="css-label3 radGroup1"></label>
                            </div>
                            <div class="basicrow f-med roboto-b">{{role.name}}</div>
                            <div class="basicrow m-top-u-i">
                                {{role.description}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="basicrow m-bott msidespad">
            <div class="basicrow topbord">
                <div class="basicrow m-top-u-i">
                    <a class="btns def-i red pull-right vcenter" (click)="this.continue()">
                        <span class="tabcell">
                            Crear Usuario&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                        </span>
                    </a>
                    <a routerLink="/usersandpermissions" class="btns def-i gray pull-left vcenter">
                        <span class="tabcell">
                            Cancelar
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>